/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AddSynchronizationFromDaysRequest} from "../model/add-synchronization-from-days-request";
import {AddSynchronizationFromRecordingsRequest} from "../model/add-synchronization-from-recordings-request";
import {CheckExternalSyncStatusResponse} from "../model/check-external-sync-status-response";
import {EventState} from "../model/event-state";
import {ExternalResponseData} from "../model/external-response-data";
import {ListData} from "../model/list-data";
import {SynchEndpoint} from "../model/synch-endpoint";
import {TrainingSessionScenarioRecordingArchiveExternView} from "../model/training-session-scenario-recording-archive-extern-view";

@Injectable({
    providedIn: "root",
})
export class SimSynchronizationService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public addSynchronizationFromDays(request: AddSynchronizationFromDaysRequest) {
        return super.post<number>(`/api/Synchronization/AddSynchronizationFromDays`, request);
    }

    public addSynchronizationFromRecordings(request: AddSynchronizationFromRecordingsRequest) {
        return super.post<string[]>(`/api/Synchronization/AddSynchronizationFromRecordings`, request);
    }

    public checkExternalSyncStatus() {
        return super.get<CheckExternalSyncStatusResponse>(`/api/Synchronization/CheckExternalSyncStatus`, );
    }

    public deleteSynchEndpoint(synchEndpoint: SynchEndpoint) {
        return super.post<boolean>(`/api/Synchronization/DeleteSynchEndpoint`, synchEndpoint);
    }

    public getAllSynchronizationEndPoints() {
        return super.get<SynchEndpoint[]>(`/api/Synchronization/GetAllSynchronizationEndPoints`, );
    }

    public getSynchEndpointById(synchEndpointId: string) {
        return super.get<SynchEndpoint>(`/api/Synchronization/GetSynchEndpointById`, {synchEndpointId: synchEndpointId});
    }

    public listTrainingSessionsWithScenarioRecordings(synchEndpointId: string, startDate: Date | string, endDate: Date | string, searchTerm: string, owner: string, scenarioId: string, userIds: string[], roomIds: string[], eventStates: EventState[], sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ExternalResponseData<ListData<TrainingSessionScenarioRecordingArchiveExternView>>>(`/api/Synchronization/ListTrainingSessionsWithScenarioRecordings`, {synchEndpointId: synchEndpointId, startDate: startDate, endDate: endDate, searchTerm: searchTerm, owner: owner, scenarioId: scenarioId, userIds: userIds, roomIds: roomIds, eventStates: eventStates, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public upsertSynchEndpoint(synchEndpoint: SynchEndpoint) {
        return super.post<boolean>(`/api/Synchronization/UpsertSynchEndpoint`, synchEndpoint);
    }
}